import script from "./SideInfoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SideInfoPanel.vue?vue&type=script&setup=true&lang=js"

import "./SideInfoPanel.vue?vue&type=style&index=0&id=bc339132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc339132"]])

export default __exports__